module.exports = __webpack_public_path__ + "dist/img/teachers-logo-dark.f6730922.png";